import { FaCalendar } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoaderScreen from '../component/loader/loaderScreen';
import { GetBlogger } from '../redux/user/blog/blogServicesSync';


export default function BlogGrid() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { articleDetails: blogs, storiesPageLoad: loading } = useSelector((state) => state.user_blog);

  useEffect(() => {
    dispatch(GetBlogger({ page: 1, limit: 6 }));
  }, [dispatch]);
    // Calculate slides by grouping posts into chunks of 6 (3 per row x 2 rows)
    const slides = [];
    for (let i = 0; i < blogs?.docs?.length; i += 6) {
      slides.push(blogs.docs.slice(i, i + 6));
    }
  
    if (loading) {
      return <LoaderScreen />;
    }
  
    return (
      <div className="container mx-auto px-4 py-12">
        {/* Swiper Grid */}
        <Swiper
          modules={[Pagination, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{ clickable: true }}
          navigation
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              {/* Slide Content */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {slide.map((post) => (
                  <article
                    key={post.id}
                    className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                  >
                    {/* Image */}
                
                    <div className="aspect-[4/3] relative overflow-hidden" >
                      <img
                        src={post.cover_pic}
                        alt={post.title}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                     onClick={() => navigate(`/blog-details/${post._id}`)}
                     />
                    </div>
  
                    {/* Content */}
                    <div className="p-6 space-y-4">
                      <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                       
                      <div className="flex items-center gap-1">
                        <FaCalendar className="w-4 h-4 text-red-500" />
                        <span className="mt-1 ml-1">{new Date(post.createdAt).toLocaleDateString()}</span>
                      </div>
                      </div>
  
                      {/* Title */}
                      <h2 className="text-xl font-bold text-gray-900 hover:text-red-600 transition-colors duration-200">
                      <Link to={`/blog-details/${post._id}`}>{post.title}</Link>
                    </h2>
  
                      {/* Excerpt */}
                      <p className="text-gray-600">{post.description}</p>
                    <Link to={`/blog-details/${post._id}`}>
                      <button className="blog__content--btn primary__btn">
                        Read more
                      </button>
                    </Link>
                    </div>
                  </article>
                ))}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }
